import { useEffect, useRef } from 'react';
import { EffectCards, Navigation, Pagination } from 'swiper/modules';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { usePatternFuncs } from '../../hooks/responsive/usePatternFuncs';
import { patternHandling } from '../../js/patternHandling';

export function Pattern({ pattern, customer_id }) {
  const slides = [...(Array.isArray(pattern) ? pattern : [])].reverse();
  const { selectedIdx, handleClick, data, handleAddNewFile } = usePatternFuncs(slides, customer_id);

  const swiperRef = useRef(null);

  useEffect(() => {
    if (!(typeof selectedIdx === 'number')) return;
    console.log('selected Id -----', selectedIdx);
    console.log('data length', data.length);
    swiperRef.current?.slideToLoop(selectedIdx, 500);
    patternHandling.selectedPattern(data[selectedIdx - 1]);
  }, [selectedIdx, data]);

  return (
    <div>
      <SwiperComponent
        slidesPerView={7}
        ref={swiperRef}
        initialSlide={selectedIdx}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          // patternHandling.selectedPattern(
          //   data[initialSlideIndex - 1 < 0 ? 0 : initialSlideIndex - 1]
          // );
        }}
        onActiveIndexChange={(swiper) => {
          patternHandling.selectedPattern(data[swiper.realIndex - 1]);
        }}
        // loop
        effect={'cards'}
        cardsEffect={{
          perSlideOffset: 70,
          slideShadows: false,
          perSlideRotate: 4,
          rotate: 10,
        }}
        modules={[Pagination, Navigation, EffectCards]}
        className="mySwiper colorSwiper"
      >
        <SwiperSlide>
          <div
            className="slider-item-center"
            style={{
              background: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              margin: 'auto',
            }}
          >
            +
            <input
              className="fullOwner_opacity"
              style={{ width: '100%', height: '100%' }}
              type="file"
              id="myfile"
              name="myfile"
              accept="image/*"
              onChange={(e) => handleAddNewFile(e)}
              value=""
            />
          </div>
        </SwiperSlide>
        {data?.map((item, index) => (
          <SwiperSlide
            key={index + 1}
            onClick={handleClick(item, index + 1)}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img
              style={{
                margin: 'auto',
              }}
              src={item.Thumbnail}
              className="colorItem"
              alt="unknow"
            />
          </SwiperSlide>
        ))}
      </SwiperComponent>
    </div>
  );
}
